module.exports = __webpack_public_path__ + "img/tishengji1.57c42854.jpg";